import { BUTTON, COUNTER } from '@/src/constants/itinerary/addons'
import { AncillaryBaggageInfo } from '@/src/types/itinerary'
import { TranslationFunction } from '@/src/types/translations'
import { isEmpty } from '@/src/utils/generalUtils'
import { isBaggageSelected } from '@/src/utils/itinerary/addons'
import { Box } from '@mui/material'
import AddonsItemCardWrapper from '../addonsItemCard'

const Baggage = ({
    baggageOptions,
    formatCurrency,
    paxCount,
    selectedBaggageOptions,
    handleAddBaggage,
    handleRemoveBaggage,
    t
}: {
    baggageOptions: AncillaryBaggageInfo[]
    formatCurrency: (price: number) => string
    paxCount: number
    selectedBaggageOptions: AncillaryBaggageInfo[]
    handleAddBaggage: (baggage: AncillaryBaggageInfo) => void
    handleRemoveBaggage: (baggage: AncillaryBaggageInfo) => void
    t: TranslationFunction<'itineraryPage.addons'>
}) => {
    return (
        <Box
            sx={{
                width: '100%',
                // Mobile: flex container, Desktop: normal
                height: { xs: '100%', lg: 'auto' },
                display: { xs: 'flex', lg: 'block' },
                flexDirection: { xs: 'column', lg: 'initial' },
                minHeight: { xs: 0, lg: 'auto' }
            }}
        >
            {/* Scrollable Baggage Grid Container */}
            <Box
                sx={{
                    // Mobile: fill flex space, Desktop: fixed maxHeight
                    flex: { xs: 1, lg: 'none' },
                    minHeight: { xs: 0, lg: 'auto' },
                    maxHeight: { xs: '100%', lg: '500px' },
                    overflowY: 'auto'
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(1, 1fr)',
                            lg: 'repeat(2, 1fr)'
                        },
                        gap: {
                            xs: 1,
                            lg: 2
                        },
                        p: 0.5
                    }}
                >
                    {baggageOptions.map((baggageOption, index) => {
                        const selectorType = paxCount > 1 ? COUNTER : BUTTON
                        const { baggageCode, displayDetail, price, baggageList } = baggageOption
                        const baggageWeight = baggageList?.[0]?.quantity
                        let description = displayDetail
                        if (!isEmpty(baggageWeight)) {
                            description = t('additonalBaggage', { baggageWeight })
                        }
                        const { isSelected, quantity } = isBaggageSelected(baggageOption, selectedBaggageOptions)
                        const totalSelections = selectedBaggageOptions.length

                        return (
                            <AddonsItemCardWrapper
                                key={`${baggageCode}-${index}`}
                                description={description}
                                price={formatCurrency(price)}
                                itemIndicator={{ show: false, color: 'success.main' }}
                                onAddClick={() => handleAddBaggage(baggageOption)}
                                onRemoveClick={() => handleRemoveBaggage(baggageOption)}
                                selectorConfig={{
                                    type: selectorType,
                                    isSelected,
                                    quantity,
                                    totalSelections,
                                    minQuantity: 0,
                                    maxQuantity: paxCount
                                }}
                            />
                        )
                    })}
                </Box>
            </Box>
        </Box>
    )
}

export default Baggage
